document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.querySelector('button[name="add"]');
  if (!addToCartButton) {
    console.error('Add to Cart button not found');
    return;
  }

  addToCartButton.addEventListener('click', (event) => {
    function logEvent(eventName, params = {}) {
      if (typeof window !== 'undefined') {
        if (window.clarity) {
          window.clarity('event', eventName);
        }
        if (window.gtag) {
          gtag('event', eventName, params);
        }
      }
    }
    if (!window.hasGeneratedImages()) {
      event.preventDefault(); // Only prevent if condition fails
      window.openImageUploadModal();
      return;
    }

    const form = addToCartButton.closest('form');

    const inputJobId = document.createElement('input');
    inputJobId.type = 'hidden';
    inputJobId.name = 'properties[jobId]';
    inputJobId.value = window.getJobId();
    form.appendChild(inputJobId);

    const inputVariant = document.createElement('input');
    inputVariant.type = 'hidden';
    inputVariant.name = 'properties[selectedVariant]';
    inputVariant.value = window.getSelectedImageVariant();
    form.appendChild(inputVariant);

    logEvent('add_to_cart_clicked', { variant_id: inputVariant.value, job_id: inputJobId.value });

    const inputThumbnail = document.createElement('input');
    inputThumbnail.type = 'hidden';
    inputThumbnail.name = 'properties[_thumbnail]';
    inputThumbnail.value = window.getSelectedImage()?.thumbnailUrl || '';
    form.appendChild(inputThumbnail);
  });
});
